var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _vm.hosting_error
        ? _c(
            "v-col",
            {
              staticClass: "pt-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "app-card",
                  attrs: {
                    text: ""
                  }
                },
                [
                  _c("v-card-text", [
                    _c(
                      "p",
                      {
                        staticClass: "mb-0"
                      },
                      [_vm._v(_vm._s(_vm.hosting_error))]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : [
            _c("service-limits", {
              staticClass: "pb-9 pl-3 pr-3",
              staticStyle: {
                width: "100%"
              },
              attrs: {
                loading: _vm.loading,
                "show-accounts": true
              }
            }),
            _c(
              "v-col",
              {
                staticClass: "pt-0 pb-0",
                attrs: {
                  cols: "12",
                  sm: "12"
                }
              },
              [
                _c("reseller-accounts-list", {
                  attrs: {
                    loading: _vm.loading
                  }
                })
              ],
              1
            ),
            _c("service-domain-server-info", {
              staticClass: "pb-0 pt-6 pl-3 pr-3",
              attrs: {
                loading: _vm.loading
              }
            }),
            _c("whm-product-info", {
              staticClass: "pt-0 pl-3 pr-3"
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }